//////// GHG 1.4 EF
const oneFourSchema = {
  title: "1.4 Direct Emissions from Fugitive Sources",
  cat: "1_4",
  catName: "cat1",
  progressiveOrderSwitch: {
    by: { level: 2, key: "sourceEFName" }, // 觀察誰
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    ////////Data Source (emissionFactorTypeId)
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    ////////Emission Factor Database Source (sourceEFName)
    {
      key: "sourceEFName",
      level: 2,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 1,
        key: "emissionFactorTypeId",
      },
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "1",
      },
      combineKey: 1,
    },
    ////////Emission Gas Type (emissionFactorId)
    {
      key: "emissionFactorId",
      level: 3,
      type: "select",
      label: "Emission Gas Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "sourceEFName",
      },
      showIf: { level: 2, key: "sourceEFName", notEmpty: true },
      combineKey: 2,
    },
    ////////Emission Gas Type (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 3,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat1CustomEFDropdownList",
      showIf: { level: 1, key: "emissionFactorTypeId", eq: "2" },
      autoFillNum:0,
    },
  ],
};

export default oneFourSchema;
